import { SetStateAction } from "react"

export function isFunctionAction<T>(
  maybeFunction: T | SetStateAction<T>,
): maybeFunction is (prevState: T) => T {
  return typeof maybeFunction === "function"
}
